import React, { useContext, useState } from "react";
import { TranslatorContext } from "../../context/Translator";
import { Col, Dropdown, Row, Form } from "react-bootstrap";
import { BusinessChartComponent, ReligiousChartComponent } from "../charts";

export default function ReligiousCardComponent({ faiths, data }) {
	const { t, n } = useContext(TranslatorContext);
  const total = data?.total_families_rescued || 1;
	const [filter, setFilter] = useState({
		filter: "",
	});

	const handleChange = (e) => {
		const { name, value } = e.target;
		setFilter((prevState) => ({
			...prevState,
			[name]: value,
		}));
	};

	return (
		<div className="mc-card">
			<div className="mc-card-header">
				<h4 className="mc-card-title">
					{t("Rescued Families Religion Index")}
				</h4>
				<Dropdown bsPrefix="mc-dropdown">
					<Dropdown.Toggle bsPrefix="mc-dropdown-toggle">
						<i className="material-icons">more_horiz</i>
					</Dropdown.Toggle>
					<Dropdown.Menu
						align="end"
						className="mc-dropdown-paper"
						style={{ width: "268px" }}
					>
						<Form.Group className="w-sm h-sm">
							<Form.Select
								name="filter"
								value={filter.filter}
								onChange={handleChange}
						gt	>
								<option value="">Select Request ID</option>
							</Form.Select>
						</Form.Group>
					</Dropdown.Menu>
				</Dropdown>
			</div>
			<Row>
				{faiths &&
					faiths.map((faith) => {
            const percent = ((faith.families_count / total) * 100).toFixed(2);
						return (
							<Col>
								<ReligiousChartComponent
									labels={faith.name}
									percent={percent}
								/>
							</Col>
						);
					})}
			</Row>

			{/* <ul className="mc-order-card-list">
                {orders.map((order, index) => (
                    <li key={ index } className="mc-order-card-item">
                        <i className={`material-icons ${ order.color }`}>{ order.icon }</i>
                        <p>{t(order.name)}</p>
                        <h5>{n(order.value )}</h5>
                    </li>
                ))}
            </ul> */}
		</div>
	);
}
